import { Stack, Typography } from "@mui/material";

interface ListItemProps {
  label: string;
  value: string;
}
export function HStackListItem(props: ListItemProps) {
  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      py="4px"
    >
      <Typography variant="body1" color="text.secondary" fontWeight={600}>
        {props.label}
      </Typography>

      <Typography variant="body1" color={"text.primary"} fontWeight={600}>
        {props.value}
      </Typography>
    </Stack>
  );
}
